<template>
    <aside
        class="fixed z-20 flex flex-col p-2.5 pt-0 top-0 bottom-0 w-[224px] lg:left-0 bg-sidebar-bg-500 dark:bg-sidebar-bg-dark-500 border-r border-divider-bg-200 dark:border-divider-bg-dark-300 transition-position duration-200 ease-in-out"
        :class="[menuState === 'opened' ? 'left-0' : 'left-[-224px]']"
    >
        <header
            class="flex items-center h-12 md:h-16 flex-row-reverse lg:flex-row flex-shrink-0"
        >
            <menu-button />
            <paperback-logo class="h-9 md:h-12 lg:ml-[12.5px]" />
            <h1
                class="mr-8 lg:ml-3 text-brand-500 text-xl font-bold font-title active:text-brand-600 transition-colors duration-300 ease-in-out"
            >
                <router-link to="/">Paperback</router-link>
            </h1>
        </header>
        <nav class="h-full py-8">
            <ul class="flex h-full flex-col align-center">
                <li class="mt-2">
                    <sidebar-base-button
                        href="settings"
                        name="Settings"
                        icon="settings"
                    />
                </li>

                <li class="mt-2" v-if="isPatron">
                    <sidebar-base-button
                        href="patreon"
                        name="Patreon"
                        icon="patreon"
                    />
                </li>
                <li class="mt-auto">
                    <sidebar-base-button
                        @click.prevent="signOut"
                        href="signout"
                        name="Sign out"
                        icon="logout"
                    />
                </li>
            </ul>
        </nav>
    </aside>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import PaperbackLogo from '@/common/components/ui/PaperbackLogo.vue'
import SidebarBaseButton from '@/common/components/ui/SidebarBaseButton.vue'
import MenuButton from '@/common/components/ui/MenuButton.vue'
import { useQuery, useResult } from '@vue/apollo-composable'
import { GET_USER_QUERY } from '@/services/apollo/requests'
import { GraphQLUserData } from '@/services/apollo/types'

export default defineComponent({
    name: 'TheSidebar',
    components: {
        PaperbackLogo,
        SidebarBaseButton,
        MenuButton,
    },
    setup() {
        const store = useStore()
        const router = useRouter()

        const colorMode = computed(() => store.getters['ui/colorMode'])

        const menuState = computed(() => store.getters['ui/menuState'])

        const signOut = () => {
            store.dispatch('auth/clearStaleState').then()
            store.dispatch('auth/removeOidcUser').then(() => router.push('/'))
            store.dispatch('ui/setMenuState', 'closed')
        }

        const { result } = useQuery(GET_USER_QUERY)
        const isPatron = useResult(result, false, (data: GraphQLUserData) =>
            data?.getUserData?.patreonStatus ? true : false
        )

        return {
            colorMode,
            signOut,
            isPatron,
            menuState,
        }
    },
})
</script>
